export default __webpack_public_path__ + "static/experiment-setup-light-39a74d3b4986e22992f100a590c176c3.png";